// extracted by mini-css-extract-plugin
module.exports = {"weddingPlanning":"WeddingPlanning_style_weddingPlanning__3uD0s"};